import { PartialPaymentsCartItem } from '@freelancer/payments-cart';
import { ContextTypeApi } from 'api-typings/payments/payments';

export function transformProjectFeeToCartItem(
  milestoneDraftId: number,
  currencyId: number,
  fee: number,
): PartialPaymentsCartItem {
  return {
    contextType: ContextTypeApi.PROJECT_FEE,
    contextId: `${milestoneDraftId}`,
    description: 'Project fee',
    currencyId,
    amount: fee,
    useBonus: false,
  };
}
